module.exports = VueECharts;